export default __webpack_public_path__ + "static/media/Grips of the Steel Behemoth.d8ccd356.jpg";